import React, { useState } from 'react';
import { withAdminWriteAccess } from 'contexts/adminAccess';
import AddIcon from '@material-ui/icons/Add';
import makeStyles from '@material-ui/core/styles/makeStyles';

import ActionButton from 'components/buttons/ActionButton';

import EditBadgeDialog from './EditBadgeDialog';

const useStyles = makeStyles((theme) => ({
  label: {
    width: '150px',
  },
}));

const AddBadgeButton = () => {
  const classes = useStyles();
  const [open, setOpen] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  return (
    <>
      <ActionButton startIcon={<AddIcon />} onClick={handleOpen} classes={{ label: classes.label }}>
        Add Badge
      </ActionButton>
      {open && <EditBadgeDialog open={open} onClose={handleClose} />}
    </>
  );
};

export default withAdminWriteAccess(AddBadgeButton);
